import { formatDate, formatNumber } from '@telerik/kendo-intl';


const abbreviateNumber = (number) => {
    let result = formatNumber(number, 'n0');
    let limit = 1000000; // 1 million
    if(number >= limit) {
        const shortNumber = (number / limit).toFixed(1);
        result = formatNumber(shortNumber, 'n1');

        // check last character and make a small adjustment
        if(result.slice(result.length - 1) === '0') {
            result = result.substr(0, result.length - 2);
        }    
        result += 'M';
    }

    limit = 1000000000; // 1 billion
    if(number >= limit) {
        const shortNumber = (number / limit).toFixed(1);
        result = formatNumber(shortNumber, 'n1');

        if(result.slice(result.length - 1) === '0') {
            result = result.substr(0, result.length - 2);
        }    
        result += 'B';
    }

    return result;
};

export const numberFormatter = {
    formatAsPercentage(number, decimals = 2){
        return formatNumber(number, 'p' + decimals);
    },
    formatAsCurrency(number, decimals = 2) {
        return formatNumber(number, 'c' + decimals);
    },
    formatShortCurrency(number){
        return new Intl.NumberFormat('en-US', 
        { notation: "compact", compactDisplay: "short",
        style: 'currency', currency: 'USD', minimumFractionDigits: 2,
        maximumFractionDigits: 2 }).format(number);
    },

    format(number, abbreviate = false) {
        let result = formatNumber(number, 'n0');
        result = abbreviate ? abbreviateNumber(number): result;
        return result;
    }
};

export const dateFormatter = {
    formatAsLongDate(date){
        return formatDate(date, 'MMMM dd, yyyy');
    },

    formatAsAbbrDate(date){
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return new Intl.DateTimeFormat('en-US', options).format(date);
    },
    getLongMonth(date){
        return new Intl.DateTimeFormat('en-US', {month: 'long'}).format(date);
    },
    getTodayLongMonth(){
        const date = this.convertDateFromLocalToUTC(new Date());
        return this.getLongMonth(date);
    },
    formatAsShortDate(date){
        return formatDate(date, 'MM/dd/yyyy');
    },
    convertDateFromLocalToUTC(date){
        const timezoneOffset = date.getTimezoneOffset() * 60000;
        return new Date(date.getTime() - timezoneOffset);
    },
    
    convertDateFromUTCToLocal(date){
        const timezoneOffset = date.getTimezoneOffset() * 60000;
        return new Date(date.getTime() + timezoneOffset);
    }
};

export const formatKey = (key, sep = '') => {
    const splitKey = key ? key.split('_') : '';
    if (splitKey.length <= 1) return key;
  
    return splitKey.reduce((summation, current, index) => {
      if (!current) return summation;
      let newWord = '';
      if (index === 0) {
        newWord = summation + current;
      } else {
        newWord = summation + sep + current[0].toUpperCase() + current.substring(1);
      }
  
      return newWord;
    }, '');
  };
  
  export const transformObject = (obj) => {
    if (!obj && typeof obj !== 'object') return obj;
    const modifiedObject = {};
    Object.keys(obj).forEach((key) => {
      modifiedObject[formatKey(key)] = obj[key];
    });
  
    return modifiedObject;
  };